import { QRCodeSVG } from 'qrcode.react';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, QRCodeWrapper, CopyInput } from '@woovi/ui';

import type { PaymentLinkQrCode_pixQrCode$key } from './__generated__/PaymentLinkQrCode_pixQrCode.graphql.ts';

type PaymentLinkQrCodeProps = {
  pixQrCode: PaymentLinkQrCode_pixQrCode$key;
};
const PaymentLinkQrCode = (props: PaymentLinkQrCodeProps): ReactNode => {
  const pixQrCode = useFragment<PaymentLinkQrCode_pixQrCode$key>(
    graphql`
      fragment PaymentLinkQrCode_pixQrCode on PixQrCode {
        brCode
      }
    `,
    props.pixQrCode,
  );

  if (!pixQrCode) {
    return null;
  }

  return (
    <>
      <QRCodeWrapper qrCodeShow data-testid='qrcode'>
        <QRCodeSVG value={pixQrCode.brCode} marginSize={4} />
      </QRCodeWrapper>
      <BoxFlex
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
        }}
      >
        <CopyInput value={pixQrCode.brCode} />
      </BoxFlex>
    </>
  );
};

export default PaymentLinkQrCode;
